import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IRegistrationInput } from '@newroom-connect/library/interfaces';

import { SignUpFormLoginComponent } from './sign-up-form-login/sign-up-form-login.component';
import { SignUpFormProfileComponent } from './sign-up-form-profile/sign-up-form-profile.component';

@Component({
  standalone: true,
  imports: [
    RouterModule,
    SignUpFormLoginComponent,
    SignUpFormProfileComponent
  ],
  selector: 'nrc-sign-up-form',
  templateUrl: './sign-up-form.component.html'
})
export class SignUpFormComponent {
  @Input() public signUpStep = signal<number>(1);
  @Input() public errorMessage?: string;

  @Output() public loginCompletedEvent = new EventEmitter<{ email: string; }>();
  @Output() public profileBackEvent = new EventEmitter<void>();
  @Output() public registerEvent = new EventEmitter<IRegistrationInput>();

  public loginData = {
    email: '',
    password: ''
  };

  public profileData: Record<string, string> = {};

  /**
   * Handle the event from the login form.
   *
   * @param event
   */
  public handleLogin(event: any): void {
    this.loginData = event;

    this.loginCompletedEvent.emit({ email: event.email });
  }

  /**
   * Handle the event from the login form.
   */
  public handleProfileBack(): void {
    this.profileBackEvent.emit();
  }

  /**
   * Handle the event from the profile form.
   *
   * @param event
   */
  public handleProfile(event: any): void {
    this.profileData = event;

    this.registerEvent.emit({ ...this.loginData, profile: this.profileData } as any);
  }
}
